import { TmrBaseResource } from 'stylewhere/api'

export default class Images extends TmrBaseResource {
  static endpoint = '/api/v1/images' // /base
}
